/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import './estimated_transfer_event';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "models": {
            "nested": {
              "TransferType": {
                "values": {
                  "TRANSFER_TYPE_DO_NOT_USE": 0,
                  "AUTOMATED_SAVINGS": 1,
                  "CHECKING_TRANSFER": 2,
                  "SAVINGS_TRANSFER": 3,
                  "EXTERNAL_TRANSFER": 4
                }
              },
              "Transfer": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fromAccountId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "toAccountId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "transferEvents": {
                    "type": ".squareup.sfs.models.EstimatedTransferEvent",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "clientToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.sfs.models.TransferType",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.models?.nested?.TransferType && !$root.nested?.squareup?.nested?.sfs?.nested?.models?.nested?.Transfer) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Describes the type of transfer.
 * --
 *
 * SOURCE TransferType @ squareup/sfs/models/transfer.proto at 12:1
 */
export const TransferType = $root.lookupEnum('squareup.sfs.models.TransferType').values;
/**
 * --
 * @desc Represents the action of moving funds between two accounts. Creation of a Transfer will produce one or more
 * Transactions (if a fee was incurred there would be two Transactions) and those will all share the same master_id.
 * --
 *
 * SOURCE Transfer @ squareup/sfs/models/transfer.proto at 24:1
 */
export const Transfer = $root.lookupType('squareup.sfs.models.Transfer');
fixType(Transfer, {
  fromAccountId: {
    required: true
  },
  toAccountId: {
    required: true
  },
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(Transfer);